import React from 'react';
import { Card } from '../../../CommonComponents/OPL/Card/Card';
import { BrowserHeader } from '../BrowserHeader/BrowserHeader';
import { EntityListHeader } from '../EntityListHeader/EntityListHeader';
import { EntityList } from '../EntityList/EntityList';
import { UploadFileList } from '../UploadFileList/UploadFileList';
import { DropZoneOverlay } from '../../../CommonComponents/OPL/Dropzone/Dropzone';
import { Box } from '../../../CommonComponents/OPL/Box/Box';

interface BrowserProps {
  isDragActive: boolean;
}

export const Browser = ({ isDragActive }: BrowserProps) => {
  return (
    <Card boxShadow="200" hasBorder>
      <BrowserHeader />

      <EntityListHeader />

      <UploadFileList />

      {isDragActive ? (
        <Box p="24">
          <DropZoneOverlay isDragActive />
        </Box>
      ) : (
        <EntityList />
      )}
    </Card>
  );
};
